module.exports = __webpack_public_path__ + "4e60f728029d8d70fbf7c74a53f8cb7e.jpg";